import { useContext, useMemo } from 'react';
import { ProjectClipsSortContext } from '../contexts/project-clips/Context';

export const useIsProjectClipColumnSorted = (column: string): 'asc' | 'desc' | false => {
  const { sort, sortDesc } = useContext(ProjectClipsSortContext);

  return useMemo(() => {
    if (sort === column) {
      return sortDesc ? 'desc' : 'asc';
    }
    return false;
  }, [column, sort, sortDesc]);
};
